<template>
  <v-row no-gutters>
    <v-col cols="12" lg="8" md="8">
      <!-- Left column -->
      <p class="text-h2">
        <template v-if="canEditOffer">
          <template v-if="hasEditableServices">
            {{ $t('ADDITIONAL_SERV_TITLE') }}
          </template>

          <template v-else>
            {{ $t('ADDITIONAL_SERV_NONE_TITLE') }}
          </template>
        </template>

        <template v-else>
          {{ $t('ADDITIONAL_SERV_LABEL') }}
        </template>
      </p>

      <p v-if="canEditOffer" class="grey-font text-body-1">
        {{
          hasEditableServices
            ? $t('ADDITIONAL_SERV_DESCRIPTION')
            : $t('ADDITIONAL_SERV_NONE_DESCRIPTION')
        }}
      </p>

      <v-expansion-panels
        v-if="hasEditableServices"
        class="mb-6 mt-12 pa-1"
        v-model="openPanelIndex"
        data-cy="additional-serv"
      >
        <v-expansion-panel
          v-for="(service, i) in editableServices"
          :key="i"
          class="mb-4"
          @click="manageHeaderClick(i, service.value)"
          :readonly="!canEditOffer"
        >
          <PanelHeader :isExpanded="isExpanded(i)" :service="service" />

          <v-expansion-panel-content>
            <PanelContentSelect
              v-if="service.type === 'LIST-VALUES'"
              :service="service"
              @onClose="closeExpanded"
              @onSaveService="handleSaveService"
            />

            <PanelContentInput
              v-else
              :service="service"
              @onClose="closeExpanded"
              @onSaveService="handleSaveService"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <NonEditableServicesDialog />
      <!-- Left column end -->
    </v-col>

    <SummaryCard>
      <template v-slot:save-and-reset-offer-buttons>
        <SaveAndResetOfferButtons @onSaveClicked="saveOffer" @onResetClicked="resetOffer" />
      </template>

      <template v-slot:offer-status-button>
        <UpdateOfferStatusButton />
      </template>
    </SummaryCard>
  </v-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { SET_OFFER_ADDITIONAL_SERVICE } from '@/store/modules/offer/mutations'
import NonEditableServicesDialog from '@/containers/offer-form/additional-services/NonEditableServicesDialog'
import PanelHeader from '@/containers/offer-form/additional-services/PanelHeader'
import PanelContentSelect from '@/containers/offer-form/additional-services/PanelContentSelect'
import PanelContentInput from '@/containers/offer-form/additional-services/PanelContentInput'
import SummaryCard from '@/components/summary-card'
import SaveAndResetOfferButtons from '@/components/buttons/SaveAndResetOfferButtons'
import UpdateOfferStatusButton from '@/components/buttons/UpdateOfferStatusButton'

export default {
  name: 'AdditionalServices',
  components: {
    SummaryCard,
    NonEditableServicesDialog,
    PanelHeader,
    PanelContentSelect,
    PanelContentInput,
    SaveAndResetOfferButtons,
    UpdateOfferStatusButton,
  },
  data() {
    return {
      openPanelIndex: null,
      priceBackup: '',
      firstTimeExpanded: false,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM, 'canEditOffer']),
    additionalServices() {
      // this[GET_OFFER_ITEM]('additionalServices') returns exclusive services of offers type B or C (data for extra-steps)
      // the confusion-prone key 'additionalServices' & 'extraServicesList' will be renamed in backend
      return this[GET_OFFER_ITEM]('extraServicesList')
    },
    editableServices() {
      return this.additionalServices?.filter(this.isEditable) ?? []
    },
    hasEditableServices() {
      return this.editableServices.length
    },
  },
  methods: {
    ...mapMutations('offer', [SET_OFFER_ADDITIONAL_SERVICE]),
    ...mapActions('alerts', ['createAlert']),
    ...mapMutations('alerts', ['removeAlert']),
    suffix(type) {
      return type === 'PERCENTAGE' ? '%' : type === 'AMOUNT' ? '€' : ''
    },
    saveOffer() {
      this.$emit('onSaveClicked')
    },
    resetOffer() {
      this.$emit('onResetClicked')
    },
    isEditable(element) {
      return element.isEditable && element.isVisible
    },
    manageHeaderClick(index, price) {
      if (!this.isExpanded(index)) {
        this.priceBackup = price
      }
    },
    isExpanded(index) {
      return this.openPanelIndex === index
    },
    closeExpanded() {
      this.openPanelIndex = null
    },
    handleSaveService(updatedService) {
      this.SET_OFFER_ADDITIONAL_SERVICE(updatedService)
    },
  },
}
</script>
